import {
    PushNotifications,
    PushNotificationSchema,
    Token,
} from '@capacitor/push-notifications'
import { initializeApp } from 'firebase/app'
import {
    deleteToken,
    getMessaging,
    getToken as getTokenForWeb,
    isSupported,
    onMessage,
} from 'firebase/messaging'
import { Capacitor } from '@capacitor/core'

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

const publicKey = process.env.REACT_APP_FIREBASE_VAMPID
const app = initializeApp(firebaseConfig)

const getFirebaseMessaging = async () => {
    const supported = await isSupported().catch(() => false)

    if (!supported) {
        console.log('Your browser doesn`t support Firebase SDK')
        return null
    }

    try {
        return getMessaging(app)
    } catch (error) {
        console.warn('HTTPS required')
        console.error(error)
    }
}

export const requestToken = async (): Promise<string> => {
    console.log('requestToken')
    if (Capacitor.isNativePlatform()) {
        console.log('is native platform')

        const isAllowedAndroidNotifications =
            await requestNotificationPermissionsForAndroid()

        if (isAllowedAndroidNotifications) {
            try {
                console.log('isAllowedAndroidNotifications')

                return await getTokenForAndroid()
            } catch (error) {
                console.error(
                    'An error occurred while retrieving token. ',
                    error
                )
                return ''
            }
        }

        return ''
    }

    const messaging = await getFirebaseMessaging()
    console.log('messaging', messaging)
    if (!messaging) {
        return ''
    }

    try {
        console.log('delete old token')
        const res = await deleteToken(messaging)
        console.log('old token deleted', res)
    } catch (err) {
        console.log('old token not deleted', err)
        // Ошибка обработана, дальше не пойдет
    }

    try {
        // await deleteToken(messaging)
        //     .then((res) => {
        //         console.log('old token deleted', res)
        //     })
        //     .catch((err) => {
        //         console.log('old token not deleted', err)
        //     })

        const swRegistration = await navigator.serviceWorker.register(
            '/firebase-messaging-sw.js',
            {
                updateViaCache: 'none',
            }
        )
        return await getTokenForWeb(messaging, {
            vapidKey: publicKey,
            serviceWorkerRegistration: swRegistration,
        })
    } catch (error) {
        console.error('An error occurred while retrieving token. ', error)
        return ''
    }
}

// async function unregisterActiveServiceWorkers() {
//     console.log('Unregistering all active service workers...')

//     const registrations = await navigator.serviceWorker.getRegistrations()

//     if (!registrations.length) {
//         console.log('No active service workers found.')
//         return
//     }

//     const unregistrationPromises = registrations.map(async (registration) => {
//         // Получаем текущего активного воркера (если есть)
//         const worker =
//             registration.active ||
//             registration.waiting ||
//             registration.installing

//         if (!worker) {
//             console.log('No active/waiting/installing worker found')
//             await registration.unregister()
//             return
//         }

//         // Слушаем изменения статуса, чтобы знать, когда он станет redundant
//         const stateChangePromise = new Promise((resolve) => {
//             worker.addEventListener('statechange', () => {
//                 console.log(`Worker state changed to ${worker.state}`)
//                 if (worker.state === 'redundant') {
//                     resolve(true)
//                 }
//             })
//         })

//         // Вызываем unregister
//         const isUnregistered = await registration.unregister()

//         if (isUnregistered) {
//             console.log('Service worker unregistration started')
//         } else {
//             console.warn('Service worker was not unregistered')
//         }

//         // Ждём, пока он станет redundant
//         await stateChangePromise
//         console.log('Service worker fully deactivated')
//     })

//     await Promise.all(unregistrationPromises)
// }

export const onMessageListener = async (
    callback: (message: { id: string; text: string }) => void
): Promise<void> => {
    if (Capacitor.isNativePlatform()) {
        PushNotifications.addListener(
            'pushNotificationReceived',
            (notification: PushNotificationSchema) => {
                callback({
                    id: notification.id,
                    text: notification.data?.message || '',
                })
            }
        )

        return
    }

    const messaging = await getFirebaseMessaging()

    if (!messaging) {
        return
    }

    onMessage(messaging, (payload) => {
        callback({
            id: payload.messageId,
            text: payload.data?.message || '',
        })
    })
}

const requestNotificationPermissionsForAndroid = async (): Promise<boolean> => {
    const checkPermissionsResult = await PushNotifications.checkPermissions()

    if (checkPermissionsResult.receive === 'granted') {
        return true
    }

    const requestPermissionsResult =
        await PushNotifications.requestPermissions()

    if (requestPermissionsResult.receive === 'denied') {
        console.warn('Push Notification permission denied')
        return false
    }

    return true
}

const getTokenForAndroid = (): Promise<string> => {
    PushNotifications.register()

    return new Promise((resolve, reject) => {
        PushNotifications.addListener('registration', (token: Token) => {
            resolve(token.value)
        })

        PushNotifications.addListener('registrationError', (error: any) => {
            reject(error)
        })
    })
}
